import React from 'react';
import { useTranslation } from 'react-i18next';
import { TEAM_ICONS } from 'utils/icons';
import config from 'utils/config';
import Button from 'components/Button';
import Panel from 'components/Panel';
import Text from 'components/Text';
import Stack from 'components/Stack';
function ShareTypeSelector(_ref) {
  var audience = _ref.audience,
    onChange = _ref.onChange;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var adminsCanShareWithEveryone = config.everyoneSharing !== false;
  var isNotAdminContent = audience !== 'admin';
  return /*#__PURE__*/React.createElement(Panel, null, /*#__PURE__*/React.createElement(Stack, {
    spacing: "xs"
  }, /*#__PURE__*/React.createElement(Text, {
    bold: true,
    id: "share-subtitle"
  }, t('modal_share_content_message')), /*#__PURE__*/React.createElement(Button, {
    align: "left",
    variant: "shaded",
    icon: "user",
    fullWidth: true,
    onClick: function onClick() {
      return onChange('users');
    }
  }, t('state_individual_users')), isNotAdminContent && /*#__PURE__*/React.createElement(Button, {
    align: "left",
    variant: "shaded",
    icon: TEAM_ICONS.TEAM,
    fullWidth: true,
    onClick: function onClick() {
      return onChange('teams');
    }
  }, t('content_type_team_plural')), isNotAdminContent && adminsCanShareWithEveryone && /*#__PURE__*/React.createElement(Button, {
    align: "left",
    variant: "shaded",
    icon: "globe",
    fullWidth: true,
    onClick: function onClick() {
      return onChange('everyone');
    }
  }, t('state_everyone'))));
}
export default ShareTypeSelector;